import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'
import find from 'lodash/find'
import Checkbox from '@components/Checkbox'
import OptionGroup from '@components/OptionGroup'

class Details extends Component {
  static propTypes = {
    employeeStore: PropTypes.object,
    userStore: PropTypes.object,

    staticData: PropTypes.object
  }

  handlePermissionsChange = permissions => {
    const { employee, update } = this.props.employeeStore

    employee.permissions.replace(permissions)
    update(employee)
  }

  render () {
    if (!this.props.userStore.isAdmin()) {
      return null
    }
    const { employeeStore, staticData } = this.props
    const { employee } = employeeStore
    const { permissions, CONST } = staticData

    const employeePermissions = permissions.filter(permission => {
      return ![
        CONST.PERMISSIONS.BASIC_CLIENT,
        CONST.PERMISSIONS.BASIC_EXPERT
      ].includes(permission.id)
    })

    return (
      <DocumentTitle title={`Employee permissions | Atheneum Partners`}>
        <div className='permissions-tab-wrapper'>
          <h2>Permissions</h2>
          <OptionGroup
            noStyle
            className='permissions-wrapper'
            items={employeePermissions.map(item => item.id)}
            itemToString={item => find(permissions, { id: item }).prettyName}
            selectedItems={employee.permissions.slice()}
            renderItem={PermissionCheckbox}
            onChange={this.handlePermissionsChange}
          />
        </div>
      </DocumentTitle>
    )
  }
}

function PermissionCheckbox ({ item, toggleItem, isSelected, itemToString }) {
  return (
    <Checkbox
      key={item}
      value={isSelected(item)}
      label={itemToString(item)}
      onChange={() => toggleItem(item)}
    />
  )
}

PermissionCheckbox.propTypes = {
  item: PropTypes.any,
  toggleItem: PropTypes.func,
  isSelected: PropTypes.func,
  itemToString: PropTypes.func
}

export default inject(
  'employeeStore',
  'staticData',
  'userStore'
)(observer(Details))
